import ContactForm from "../components/ContactForm";
import Hero from "../components/Hero";
import contactImg from "../assests/images/contact-bg.jpg";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

export default function ContactUs() {
  return (

    <>
      <Helmet>
        <title>
          Contact Us | Dubai Cheap Hotels
        </title>

        <meta
          name="description"
          content="Contact Dubai Cheap Hotels for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <link
          rel="canonical"
          href="http://127.0.0.1:8000/contact-us"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Contact Us | Dubai Cheap Hotels"
        />

        <meta
          property="og:description"
          content="Contact Dubai Cheap Hotels for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <meta
          property="og:url"
          content="http://127.0.0.1:8000/contact-us"
        />

        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Contact Us | Dubai Cheap Hotels"
        />

        <meta
          name="twitter:description"
          content="Contact Dubai Cheap Hotels for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>


      <div className="w-full overflow-hidden">
        <Hero
          variant="inner"
          title="Contact Us"
          subtitle="We’re here to help you with bookings and inquiries"
          backgroundImage={contactImg}
        />

        {/* Contact Info Cards */}

        <section className="py-12 bg-white">
          <div className="max-w-screen-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 px-4 text-center">

            <div className="p-6 shadow-xl rounded-xl border border-[#FF6B35] hover:shadow-[0_20px_40px_rgba(255,107,53,0.15)] transition">

              <FaMapMarkerAlt className="text-[#FF6B35] text-2xl mx-auto mb-3" />

              <h3 className="text-base sm:text-lg font-semibold mb-2">
                Location
              </h3>
              <p className="text-gray-600">Dubai, UAE</p>
            </div>

            <div className="p-6 shadow-xl rounded-xl border border-[#FF6B35] hover:shadow-[0_20px_40px_rgba(255,107,53,0.15)] transition">

              <FaPhoneAlt className="text-[#FF6B35] text-2xl mx-auto mb-3" />

              <h3 className="text-base sm:text-lg font-semibold mb-2">
                Phone
              </h3>
              <p className="text-gray-600">+971 123 456 789</p>
            </div>

            <div className="p-6 shadow-xl rounded-xl border border-[#FF6B35] hover:shadow-[0_20px_40px_rgba(255,107,53,0.15)] transition">

              <FaEnvelope className="text-[#FF6B35] text-2xl mx-auto mb-3" />

              <h3 className="text-base sm:text-lg font-semibold mb-2">
                Email
              </h3>
              <p className="text-gray-600">support@yourwebsite.com</p>
            </div>

          </div>
        </section>

        {/* Contact Form */}
        <ContactForm />

        {/* Map Section */}
        <section className="py-12">
          <div className="max-w-screen-2xl mx-auto px-4 sm:px-6">
            <h2 className="text-2xl font-bold mb-6 text-center">
              Find Us on Map
            </h2>

            <div className="rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps?q=Dubai&output=embed"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px]"
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <h2 className="text-2xl font-bold mb-6 text-center">
              Frequently Asked Questions
            </h2>

            <div className="space-y-3 sm:space-y-4">
              <div className="p-4 sm:p-5 bg-white shadow rounded-lg">
                <h4 className="font-semibold">How fast do you respond?</h4>
                <p className="text-gray-600">Usually within 24 hours.</p>
              </div>

              <div className="p-4 sm:p-5 bg-white shadow rounded-lg">
                <h4 className="font-semibold">Can I customize my tour?</h4>
                <p className="text-gray-600">Yes, we offer fully customizable tours.</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}